export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const PASSWORD_PATTERN =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,32}$/
export const ESTIMATION_PATTERN =
    /^([0-9]+w?(?=\s[0-9]+(d|h|m)|\s*$)\s*)?([0-9]+d?(?=\s[0-9]+(h|m)|\s*$)\s*)?([0-9]+h?(?=\s[0-9]+m|\s*$)\s*)?([0-9]+m\s*)?$/
export const HOST_PATTERN =
    /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/
export const PORT_PATTERN =
    /^((6553[0-5])|(655[0-2][0-9])|(65[0-4][0-9]{2})|(6[0-4][0-9]{3})|([1-5][0-9]{4})|([0-5]{0,5})|([0-9]{1,4}))$/gi
